// @flow
import React from "react";
import { Map, TileLayer } from "react-leaflet";
import classNames from "classnames";
import { withGlobalContext } from "../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Paper from "elevate-ui/Paper";
import StyledMarker from "../common/StyledMarker";
type $Props = {
  classes: Object,
  mapProvider: Object,
  mapTypeId: string,
  className: string,
  location: { lat: number, lng: number },
  zoom: number,
};
type $State = {
  bounds: Array<{ lat: number, lng: number }>,
  container: any,
};
class SellerMap extends React.Component<$Props, $State> {
  SellerMap: any;

  render() {
    const { classes, mapProvider, className, location, zoom } = this.props;
    const position = [location.lat, location.lng];
    return (
      <div className={classNames(classes.container, className)}>
        <Paper>
          <Map
            center={position}
            zoom={zoom}
            zoomControl={false}
            attributionControl={false}
            scrollWheelZoom={false}
            className={classes.map}
            //ref={this.refContainer}
            dragging={false}
            maxZoom={mapProvider.maxZoom}
          >
            <TileLayer
              attribution={mapProvider.attribution}
              url={mapProvider.url}
              maxZoom={mapProvider.maxZoom}
              id={mapProvider.tileLayers.street}
            />
            <StyledMarker position={position} classes={classes} label={""} />
          </Map>
        </Paper>
      </div>
    );
  }
}

const styles = (theme) => {
  const tabletP = 768;

  return {
    root: {
      width: "100%",
    },
    container: {},
    map: {
      width: "calc(70vw - 48px)",
      height: "calc(50vw - 48px)",
      [`@media (min-width: ${tabletP}px)`]: {
        height: "calc(70vw - 48px)",
      },

      zIndex: "0",
      maxWidth: "300px",
      maxHeight: "300px",
    },
    popup: {
      borderRadius: theme.globalBorderRadius,
      boxShadow: theme.globalBoxShadow,
      overflow: "hidden",
      "& .leaflet-popup-close-button": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        top: "4px !important",
        right: "7px !important",
        width: "25px !important",
        height: "25px !important",
        color: `${theme.colors.white} !important`,
        font: "inherit !important",
        fontSize: "25px !important",
        fontWeight: "700 !important",
        padding: "4px !important",
        borderRadius: "50% !important",
        background: `${theme.colors.gray["100"]} !important`,
      },
    },
    mapPin: {
      position: "absolute",
      zIndex: theme.zIndex["mapPin"],
      cursor: "pointer",
      // white circle
      "&:before": {
        content: "''",
        position: "absolute",
        top: 0,
        left: 0,
        display: "block",
        width: "16px",
        height: "16px",
        margin: "-2px", // We're given a 12px box to work with– since we set this to be 16px, we need to adjust it to re-center it
        boxShadow: theme.globalBoxShadow,
        borderRadius: "50%",
        background: "white",
      },
      // primary color circle
      "&::after": {
        content: "''",
        position: "absolute",
        top: "0",
        left: "0",
        display: "block",
        width: "12px",
        height: "12px",
        boxShadow: "inset 0 0 1px 0 rgba(0, 0 , 0, 0.3)",
        borderRadius: "50%",
        background: theme.colors.green["500"],
      },
      "&:hover": {
        zIndex: theme.zIndex["mapPinHover"],
      },
    },
  };
};
export default withStyles(styles)(withGlobalContext(SellerMap));
